// ======================================================================
// File Name       : ServiceGroupDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as enterpriseActions from '../../../actions/EnterpriseAction';
import TreeView from '../../../components/Tree';

class ServiceGroupDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      data: [],
      groupList: [],
      selectedTargetEnterprise: {},
      fetchData: false,
    };
    this.handleSelectNode = this.handleSelectNode.bind(this);
    this.onOK = this.onOK.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(enterpriseActions.init());
  }

  onOK() {
    const { selectedTargetEnterprise } = this.state;
    if (Object.keys(selectedTargetEnterprise).length > 0) {
      this.props.onSelectGroup(selectedTargetEnterprise);
    }
    this.props.openGroupSelectDialog();
    this.setState({
      selectedTargetEnterprise: {},
    });
  }

  onCancel() {
    this.setState({
      selectedTargetEnterprise: {},
      cancel: true,
    },
    () => {
      this.props.openGroupSelectDialog();
    });
  }

  handleSelectNode(event, nodes) {
    if (!nodes || !nodes.data) return;
    if (this.state.cancel) {
      this.setState({
        cancel: false,
      });
    } else {
      const selectedTargetEnterprise = nodes.data.callbackData;
      this.setState({ selectedTargetEnterprise });
    }
  }

  createTree() {
    const { bySecernId, allSecernIds, isSupperUserL0 } = this.props;
    const buildNodeData = (acc, enterpriseCd) => {
      const enterprise = bySecernId[enterpriseCd];
      // #7486 START
      let enterpriseName  = enterprise.enterpriseName;
      if(isSupperUserL0){
        enterpriseName = `${enterpriseName}(${enterprise.enterpriseCd})`;
      }
      // #7486 END
      if (!enterprise) return acc;
      const { child = [] } = enterprise;
      const children = child.reduce(buildNodeData, []);

      const className = '';
      acc.push({
        id: enterpriseCd,
        a_attr: { class: className },
        text: enterpriseName,
        icon: false,
        data: { menu: null, callbackData: enterprise },
        state: {
          selected: Object.keys(this.state.selectedTargetEnterprise).length > 0
          ? (this.state.selectedTargetEnterprise
            && enterprise.enterpriseCd === this.state.selectedTargetEnterprise.enterpriseCd)
          : (this.props.serviceRecordSearch
            && enterprise.enterpriseCd === this.props.serviceRecordSearch.values.selectedEnterprise),
        },
        children,
      });
      return acc;
    };
    return allSecernIds.reduce(buildNodeData, []);
  }

  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    const {
        show,
    } = this.props;
    const nodes = this.createTree();
    return (
      <Modal
        show={show}
        animation={false}
        size={'lg'}
      >
        <Modal.Header onHide={this.onCancel} closeButton>
          <Modal.Title className="text-center">{'企業を選択してください'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col sm={12}>
            <TreeView
              data={nodes}
              openAll
              isNotRefresh
              ref={(instance) => {
                this.treeInstance = instance;
              }}
              onSelectNode={this.handleSelectNode}
              onCancelAll={this.props.openGroupSelectDialog}
            />
          </Col>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button key={0} variant="default" className="btn-96" onClick={this.onCancel}>
            {'キャンセル'}
          </Button>
          <Button key={1} className="btn-96 btn-primary" onClick={this.onOK}>
            {'OK'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { enterprises } = state.enterprise;
  const { serviceRecordSearch } = state.form;
  return { ...enterprises, ...{ serviceRecordSearch } };
};

export default connect(mapStateToProps)(ServiceGroupDialog);
